export const PREFORM_FIELDS = [
  {
    name: 'rut',
    inputAdornment: '',
    label: 'RUT',
    textArea: '',
    disabled: false,
    required: true,
    helper: 'Sin puntos, pero con guión Ej: 12345678-9',
  },
  {
    name: 'serie',
    inputAdornment: '',
    label: 'N° de documento cédula de identidad',
    textArea: '',
    disabled: false,
    required: true,
    info: true,
    helper: '',
  },
];
